import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import { ApiError } from '@/api/http-client';

/**
 * Mapeia o 422 do servidor para os campos do formulário.
 *
 * O backend já devolve `detalhes: { campo: ["mensagem"] }` no envelope de erro
 * — o `ApiError` sempre carregou esse campo e **nada nunca o usou**. Todo erro
 * de validação virava um banner genérico no topo, e o usuário tinha de caçar
 * qual campo estava errado.
 *
 * O que não casa com nenhum campo do formulário cai em `root`, que é onde o
 * `<Alert>` do topo já lê.
 *
 * ```ts
 * catch (erro) {
 *   aplicarErrosDoServidor(erro, setError, 'Não foi possível salvar o cargo.');
 * }
 * ```
 */
export function aplicarErrosDoServidor<T extends FieldValues>(
  erro: unknown,
  setError: UseFormSetError<T>,
  mensagemPadrao: string,
): void {
  if (!(erro instanceof ApiError)) {
    setError('root', { message: mensagemPadrao });
    return;
  }

  const detalhes = erro.detalhes;
  if (!detalhes || Object.keys(detalhes).length === 0) {
    setError('root', { message: erro.message });
    return;
  }

  const soltos: string[] = [];

  for (const [campo, mensagens] of Object.entries(detalhes)) {
    const mensagem = mensagens.join(' ');

    // `(raiz)` é o que o filtro do backend usa para issue sem path.
    if (campo === '(raiz)') {
      soltos.push(mensagem);
      continue;
    }

    setError(campo as Path<T>, { message: mensagem });
  }

  if (soltos.length > 0) {
    setError('root', { message: soltos.join(' ') });
  }
}
